import Items from './Items';
import {vegpizza,nonvegpizza} from './services/ItemsApi'





const ItemsDisplay = ({type}) => {
    const itemslist = type==="Veg Pizza"?vegpizza():nonvegpizza();
    const itemsDis = itemslist.map((items,index)=><Items key = {index} name={items.name} rprice = {items.rprice} mprice = {items.mprice} lprice={items.lprice}     />);
    return <div>
    {itemsDis}
    
        </div>
}
 
export default ItemsDisplay;